import React from "react";
import { Tooltip } from "react-tooltip";

// wraps the 3rd party lib for substitution
// note this will not work in shadow dom, use react bootstrap tooltip instead
// 
// usage:
// Make sure <TooltipContainer /> is rendered in the component tree
//
// In the client component use the id that corresponds to the variant you want
// eg:
//   <a
//     data-tooltip-content={tr("config_options")}
//     data-tooltip-id="light-tooltip"
//   >
export default function TooltipContainer() {
  return (
    <>
      <Tooltip variant="light" id="light-tooltip" />
      <Tooltip variant="dark" id="dark-tooltip" />
    </>
  )
}